export default {
  en: {
    heimdall: "Heimdall",
    dashboard: "Dashboard",
    dashboardSites: "Dashboard : sites",
    dashboardServers: "Dashboard : servers",
    dashboardRefresh: "Dashboard refresh time",
    site: "Site",
    sites: "Sites",
    newSite: "New site",
    editSite: "Edit site",
    siteDetails: "Site details",
    siteTypesDetails: "Techno details",
    invoicedAmount: "Invoiced amount (€)",
    link: "Link",
    server: "Server",
    servers: "Servers",
    newServer: "New server",
    editServer: "Edit server",
    serverDetails: "Server details",
    ip: "IP",
    seconds: "seconds",
    na: "n/a",
    go: " Go",
    go_: " (Go)",
    cpuThreshold: "CPU threshold",
    memoryThreshold: "Memory threshold",
    diskThreshold: "Disk threshold",
    beforeNotification: "Before notification",
    pingInterval: "Ping interval",
    pricing: "Pricing",
    costServer: "Cost of server (€)",
    costHardDisk: "Cost of hard disk (€)",
    auxiliaryCost: "Auxiliary cost (€)",
    rds: "RDS (€)",
    backup: "Backup (€)",
    bandwidth: "Bandwidth (€)",
    support: "Support (€)",
    ipElastic: "Elastic IP",
    specification: "Specifications",
    typeServer: "Type of server",
    nbCPU: "Number of CPU",
    nbRAM: "Number of RAM",
    nbServer: "Number of server",
    nbSite: "Number of site",
    nbProject: "Number of project",
    diskSpace: "Disk space",
    hosting: "Hosting",
    hostingCosts: "Hosting cost",
    maintenanceCosts: "Maintenance Cost",
    cpu: "CPU",
    memory: "Memory",
    drive: "Drive",
    reservedInstance: "Reserved instance",
    localization: "Localization",
    birthday: "Birthday",
    monthly: "(monthly)",
    annualy: "(annualy)",
    weekly: "(weekly)",
    stats: "Stats",
    referenceTime: "Reference time",
    errorRecurrence: "Error recurrence",
    isEnabled: "Enable ?",
    enabled: "Enabled",
    disabled: "Disabled",
    occurences: "occurences",
    info: "Info",
    type: "Type",
    users: "Users",
    user: "User",
    newUser: "New user",
    editUser: "Edit user",
    userDetails: "User details",
    provider: "Provider",
    providers: "Providers",
    providerDetails: "Provider details",
    monitoring: "Monitoring",
    cost: "Cost",
    billing: "Billing",
    delta: "Delta",
    email: "Email",
    financial: "Hostings",
    projects: "Commerce",
    project: "Project",
    newProject: "New project",
    editProject: "Edit project",
    projectDetails: "Project details",
    yes: "Yes",
    no: "No",
    add: "Add",
    view: "View",
    new: "New",
    back: "Back",
    edit: "Edit",
    settings: "Settings",
    setup: "Heimdall Setup",
    login: "Login",
    logout: "Logout",
    search: "Search",
    remove: "Remove",
    save: "Save",
    refresh: "Refresh",
    issue: "issue",
    noIssue: "No issue",
    editServerAdministrators: "Edit server administrators",
    editSiteAdministrators: "Edit site administrators",
    noUsersServer: "No users for this server",
    placeholderUsername: "Enter username or email",
    name: "Name",
    title: "Title",
    customer: "Customer",
    date: "Date",
    startDate: "Start date",
    endDate: "End date",
    creationDate: "Creation date",
    selectDate: "Select date",
    techno: "Main techno",
    siteType: "Techno",
    siteTypes: "Technos",
    manager: "Manager",
    status: "Status",
    benefits: "Benefits",
    projectMantis: "Mantis project ID",
    description: "Description",
    serverDescription: "Server description",
    quoteNumber: "Quote number",
    invoiceNumber: "Invoice number",
    amount: "Amount",
    months: "Months",
    days: "Days",
    numberDay: "Number of days",
    adr: "Average daily rate",
    forecastedWorkload: "Forecasted workload",
    grossProfit: "Gross profit",
    comment: "Comment",
    byDay: "by day",
    writeComment: "Write a comment",
    dangerZone: "Danger zone",
    removeServer: "Removing the server will delete all related logs.",
    removeSite: "Removing the site will delete all related logs.",
    removingServer: "Removing the server cannot be undone !",
    removingSite: "Removing the site cannot be undone !",
    removingProject: "Removing the server cannot be undone !",
    removingUser: "Removing the user cannot be undone !",
    removingMaintenance: "Removing TMA cannot be undone !",
    password: "Password",
    changePassword: "Change password",
    newPassword: "New password",
    confirmationPassword: "Confirmation password",
    endpoints: "Endpoints",
    integrityKey: "Integrity key",
    port: "Port",
    domain: "Domain",
    fr: "French",
    en: "English",
    Development: "Development",
    License: "License",
    Hosting: "Hosting",
    TMA: "TMA",
    New: "New",
    Quotation: "Quotation",
    Validated: "Validated",
    Billing: "Billing",
    Cancelled: "Cancelled",
    noBillingData: "No billing data",
    noPrice: "No price",
    Error404: "Error 404",
    pageError404: "Oops! The page you are looking for does not exist.",
    GoToHomepage: "Go to Home page",
    emailExist: "This email already exists !",
    ipExist: "A server with this IP already exists !",
    errorOccured: "An error occured :(",
    loginSuccessful: "Login successful !",
    loginFailed: "Login failed !",
    updateSuccessful: "Update successful",
    deleteSuccessful: "Delete successful",
    updateInvoiceSuccessful: "Update invoice successful",
    addInvoiceSuccessful: "Add invoice successful",
    addInvoiceMaintenanceSuccessful: "Add invoice successful",
    newProjectcreated: "New project created",
    newMaintenancecreated: "New TMA created",
    newServercreated: "New server created",
    newSitecreated: "New site created",
    newUsercreated: "New user created",
    configSaved: "Config saved",
    close: "Close",
    userLogout: "You have been logout",
    totals: "Totals",
    TMA: "TMA",
    nameWebsite: "Name of website",
    prodWebsite: "Url of website production",
    stagingWebsite: "Url of website staging",
    siteAndApplication: "Site / Application",
    tmas: "TMA",
    maintenance: "Maintenance",
    maintenances: "Maintenance",
    maintenanceCost: "Maintenance cost",
    maintenanceDetails: "TMA Details",
    editMaintenance: "Edit TMA",
    amountTotal: "Amount total",
    sold: "Solde",
    errorSold: "Please change the total amount duty free",
    occurences: "occurences",
    newMonitoring: "New monitoring",
    editMonitoring: "Edit monitoring",
    monitorings: "Project monitoring",
    projectMonitoring: "Project monitoring",
    conductedMonitoring: "Conducted monitoring",
    remainingMonitoring: "Remaining monitoring",
    contract: "Contract",
    meeting: "Meetings",
    projection: "Projection",
    remaining: "Remaining",
    done: "Done",
    clientPrice: "Client price",
    objective: "Objective",
    objectiveMargin: "Objective margin",
    doneMargin: "Margin realized",
    margin: "Margin",
    projectPrice: "project price",
    soldPrice: "Price",
    employees: "Employees",
    employee: "Employee",
    newEmployee: "New employee",
    editEmployee: "Edit employee info",
    dailySalary: "Daily salary",
    numberDayPrice: "Number days client price",
  },
  fr: {
    heimdall: "Heimdall",
    dashboard: "Tableau de bord",
    dashboardSites: "Tableau de bord : Sites",
    dashboardServers: "Tableau de bord : Serveurs",
    dashboardRefresh: "Temps de rafraîchissement",
    site: "Site",
    sites: "Sites",
    newSite: "Nouveau site",
    editSite: "Modifier site",
    siteDetails: "Détail du site",
    siteTypesDetails: "Détail de la techno",
    invoicedAmount: "Montant facturé (€)",
    link: "URL du site",
    server: "Serveur",
    servers: "Serveurs",
    newServer: "Nouveau serveur",
    editServer: "Modifier serveur",
    serverDetails: "Détail du serveur",
    ip: "IP",
    seconds: "secondes",
    na: "n/a",
    go: " Go",
    go_: " (Go)",
    cpuThreshold: "Seuil du CPU",
    memoryThreshold: "Seuil de la RAM",
    diskThreshold: "Seuil du disque dur",
    beforeNotification: "Nombre de notifications",
    pingInterval: "Intervalle de ping",
    pricing: "Prix",
    costServer: "Coût du serveur",
    costHardDisk: "Coût du disque dur",
    auxiliaryCost: "Coût annexe",
    rds: "RDS",
    backup: "Backup",
    bandwidth: "Bande passante",
    support: "Support",
    ipElastic: "IP Elastic",
    specification: "Spécification",
    typeServer: "Type de serveur",
    nbCPU: "Nombre de CPU",
    nbRAM: "Nombre de RAM",
    nbServer: "Nombre de serveur",
    nbSite: "Nombre de site",
    nbProject: "Nombre de projet",
    diskSpace: "Espace de disque dur",
    hosting: "Hébergement",
    hostingCosts: "Coût de l'hébergement",
    maintenanceCosts: "Coût de la maintenance",
    cpu: "CPU",
    memory: "Mémoire",
    drive: "Disque dur",
    reservedInstance: "Instance réservée",
    localization: "Localisation",
    birthday: "Date d'anniversaire",
    monthly: "(mensuel)",
    annualy: "(annuel)",
    weekly: "(hebdomadaire)",
    stats: "Statistiques",
    referenceTime: "Temps de référence",
    errorRecurrence: "Nombre d'erreurs récurrentes",
    isEnabled: "Activer ?",
    enabled: "Activé",
    disabled: "Désactivé",
    occurences: "occurences",
    info: "Info",
    type: "Type",
    financial: "Hébergements",
    users: "Utilisateurs",
    user: "Utilisateur",
    newUser: "Nouvel utilisateur",
    editUser: "Modifier l'utilisateur",
    userDetails: "Détail de l'utilisateur ",
    provider: "Fournisseur",
    providers: "Fournisseurs",
    providerDetails: "Détail du fournisseur",
    monitoring: "Statut",
    cost: "Coût",
    billing: "Facturation",
    delta: "Delta",
    email: "E-mail",
    projects: "Commerces",
    project: "Projet",
    newProject: "Nouveau projet",
    editProject: "Modifier le projet",
    projectDetails: "Détail du projet",
    yes: "Oui",
    no: "Non",
    add: "Ajouter",
    view: "Voir",
    new: "Nouveau",
    back: "Retour",
    edit: "Modifier",
    settings: "Réglages",
    setup: "Mise en place d'Heimdall",
    login: "Connexion",
    logout: "Déconnexion",
    search: "Rechercher",
    remove: "Supprimer",
    save: "Sauvegarder",
    refresh: "Rafraichir",
    issue: "Problème",
    noIssue: "Pas de problème",
    editServerAdministrators: "Modifier l'administrateur du serveur",
    editSiteAdministrators: "Modifier l'administrateur du site",
    noUsersServer: "Pas d'utilisateur pour ce serveur",
    placeholderUsername: "Entrer nom ou un e-mail",
    name: "Nom",
    title: "Titre",
    customer: "Client",
    date: "Date",
    startDate: "Date de début",
    endDate: "Date de fin",
    creationDate: "Date de création",
    selectDate: "Choissisez une date",
    techno: "Techno principale",
    siteType: "Techno",
    siteTypes: "Technos",
    manager: "Responsable",
    status: "Statut",
    benefits: "Type de prestation",
    projectMantis: "ID du projet Mantis",
    description: "Description",
    serverDescription: "Description du serveur",
    quoteNumber: "Numéro de devis",
    invoiceNumber: "Numéro de facture",
    amount: "Montant HT",
    months: "Mois",
    days: "Jours",
    numberDay: "Nombre de jours",
    adr: "Temps journalier moyen",
    forecastedWorkload: "Charges prévisionnelles",
    grossProfit: "Marge brute",
    comment: "Commentaire",
    byDay: "par jour",
    writeComment: "Écrire un commmentaire",
    dangerZone: "Zone de danger",
    removeServer: "La suppression du serveur supprimera tous les logs associés.",
    removeSite: "La suppression du site supprimera tous les logs associés.",
    removingServer: "La suppression du serveur ne peut pas être annulée !",
    removingSite: "La suppression du site ne peut pas être annulée !",
    removingProject: "La suppression du projet ne peut pas être annulée !",
    removingUser: "La suppression de l'utilisateur ne peut pas être annulée !",
    removingMaintenance: "La suppression de la TMA ne peut pas être annulée !",
    password: "Mot de passe",
    changePassword: "Changer de mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmationPassword: "Confirmation du mot de passe",
    endpoints: "Endpoints",
    integrityKey: "Clé d'intégrité",
    port: "Port",
    domain: "Domaine",
    fr: "Français",
    en: "Anglais",
    Development: "Développement",
    License: "Licence",
    Hosting: "Hébergement",
    TMA: "TMA",
    New: "Nouveau",
    Quotation: "Devis",
    Validated: "Validé",
    Billing: "Facturé",
    Cancelled: "Annulé",
    noBillingData: "Pas de données de facturation",
    noPrice: "Prix non défini",
    Error404: "Erreur 404",
    pageError404: "Oups! La page que vous recherchez n'existe pas.",
    GoToHomepage: "Retour à la page d'accueil",
    emailExist: "Cet email existe déjà !",
    errorOccured: "Une erreur s'est produite :(",
    loginSuccessful: "Connexion réussie !",
    loginFailed: "Échec de connexion !",
    updateSuccessful: "Mise à jour réussie",
    addInvoiceSuccessful: "Ajout d'une facture réussi",
    addInvoiceMaintenanceSuccessful: "Ajout d'une facture réussi",
    updateInvoiceSuccessful: "Mise à jour de la facture réussie !",
    deleteSuccessful: "Suppression réussie",
    newProjectcreated: "Nouveau projet créé",
    newServercreated: "Nouveau serveur créé",
    newSitecreated: "Nouveau site créé",
    newMaintenancecreated: "Nouvelle TMA créé",
    newUsercreated: "Nouvel utilisateur créé",
    configSaved: "Configuration sauvegardée",
    close: "Fermer",
    userLogout: "Vous avez été déconnecté",
    totals: "Totaux",
    TMA: "TMA",
    nameWebsite: "Nom du site",
    prodWebsite: "Url du site en production",
    stagingWebsite: "Url du site en staging",
    siteAndApplication: "Site / Application",
    tmas: "TMA",
    newTma: "Nouvelle TMA",
    maintenance: "TMA",
    maintenances: "TMA",
    newMaintenance: "Nouvelle TMA",
    maintenanceCost: "Coût de la maintenance",
    maintenanceDetails: "Détail de la TMA",
    editMaintenance: "Modifier la TMA",
    amountTotal: "Montant total HT",
    sold: "Solde",
    errorSold: "Veuillez modifier le montant total HT",
    occurences: "occurences",
    monitorings: "Suivi des projets",
    newMonitoring: "Nouveau suivi",
    editMonitoring: "Modifier le suivi",
    projectMonitoring: "Suivi projet",
    conductedMonitoring: "Suivi réalisé",
    remainingMonitoring: "Suivi restant",
    contract: "Contrat",
    meeting: "Réunions",
    projection: "Projection",
    remaining: "Restant",
    done: "Réalisé",
    clientPrice: "Vente client",
    objective: "Objectif",
    objectiveMargin: "Objectif marge",
    doneMargin: "Marge réalisée",
    margin: "Marge",
    projectPrice: "vente projet",
    soldPrice: "Prix vente",
    employees: "Employés",
    employee: "Employé",
    newEmployee: "Nouvel employé",
    editEmployee: "Modifier infos employé",
    dailySalary: "Salaire journalier",
    numberDayPrice: "Nombre jours vente client",
  }
};
